import PartnerProgramPage from "@components/new-ui/partner-program/PartnerProgramPage";

const GallaboxPartnership: React.FC = () => <PartnerProgramPage />;

export default GallaboxPartnership;
